webpackJsonp([63],{

/***/ "4Yp3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-router-modals-container_129288ab615cea2022abc06d5bfbfb9e.html";

/***/ }),

/***/ "wg/K":
/***/ (function(module, exports, __webpack_require__) {

var SubscriptionRouterModalsContainer = (function () {
    function SubscriptionRouterModalsContainer() {
    }
    return SubscriptionRouterModalsContainer;
}());
angular.module('animatronApp.SubscriptionRouterModalsContainer', [])
    .component('subscriptionRouterModalsContainer', {
    controller: SubscriptionRouterModalsContainer,
    templateUrl: __webpack_require__("4Yp3")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/63-c7c98a0cc108ea8b91f3.min.js